__turbopack_context__.v({
  "className": "notoserifsc_b252aaa2-module__BviMzG__className",
  "variable": "notoserifsc_b252aaa2-module__BviMzG__variable",
});
